import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Open' },
    { value: 2, label: 'Closed' },
    { value: 3, label: 'Morning' },
    { value: 4, label: 'Afternoon' },
  ],
});
